/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcCore from "@grapecity/wijmo"
import dayjs from "dayjs"

import { Col, Container, Row } from "react-bootstrap"
import { useSelector } from "react-redux"
import CONSTANT from "../../../../constant"
import { TTenkenSeibi } from "../../../../globalStore/pageStore/syaryoMaster/tenkenSeibiData"
import { RootState } from "../../../../globalStore/rootreducer"
import { TWijmoCellTemplateContext } from "../../../../type/wijmoComponents"
import { ImmutabilityProvider } from "@grapecity/wijmo.react.grid.immutable"

type T点検整備一覧Item = TTenkenSeibi & {
  // 点検整備日: Date
}

/**
 * 点検整備履歴一覧
 * @returns
 */
const TenkenSeibiRirekiData = () => {
  //#region [selector]
  const syaryoMaster = useSelector(
    (state: RootState) => state.page.syaryoMaster
  )
  //#endregion

  //#region [method]
  //#endregion

  //#region [state]
  //#endregion

  //#region [effect]
  //#endregion

  return (
    <>
      <div className="accordion-header">
        点検整備履歴
        <div className="accordion-description">点検整備履歴一覧</div>
      </div>
      <div>
        <h5>点検整備履歴</h5>
        <Container className="register-form" fluid>
          <Row>
            <Col>
              <wjrGrid.FlexGrid {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}>
                <ImmutabilityProvider itemsSource={syaryoMaster.点検整備一覧} />

                <wjrGrid.FlexGridColumn
                  // binding="点検整備日"
                  binding="点検整備実施日"
                  width={120}
                  format="d"
                  header="点検・整備日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T点検整備一覧Item>
                    ) => {
                      const str点検整備日 = wjcCore.isNullOrWhiteSpace(
                        context.item.点検整備実施日
                      )
                        ? context.item.点検整備予定日
                        : context.item.点検整備実施日
                      const 点検整備日 = dayjs(str点検整備日).toDate()

                      return (
                        <>
                          {wjcCore.Globalize.format(new Date(点検整備日), "d")}
                        </>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="点検整備区分名称1"
                  width={200}
                  header="点検整備名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="支払先名"
                  width={200}
                  header="点検整備業者"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="メーター数値"
                  align="right"
                  header="メーター数値"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備考"
                  width={400}
                  header="備考"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="オイルエレメント交換フラグ"
                  header="オイル交換">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T点検整備一覧Item>
                    ) => {
                      return context.item.オイルエレメント交換フラグ === 1 ? (
                        <>〇</>
                      ) : (
                        <></>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="タイヤ交換フラグ"
                  header="タイヤ交換">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T点検整備一覧Item>
                    ) => {
                      return context.item.タイヤ交換フラグ === 1 ? (
                        <>〇</>
                      ) : (
                        <></>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="その他整備フラグ"
                  header="その他">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T点検整備一覧Item>
                    ) => {
                      return context.item.その他整備フラグ === 1 ? (
                        <>〇</>
                      ) : (
                        <></>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
              </wjrGrid.FlexGrid>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default TenkenSeibiRirekiData
